import { render } from "./OptionMenuAccount.vue?vue&type=template&id=19ae73bc"
import script from "./OptionMenuAccount.vue?vue&type=script&lang=js"
export * from "./OptionMenuAccount.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Github\\dev-mynet\\Products\\Hub\\web\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__